import type { IconDef } from '../types';

export const bolt: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M7.98096 24.0023C7.82096 24.0023 7.67096 23.9623 7.52096 23.8923C7.09096 23.6723 6.88096 23.1723 7.02096 22.7123L9.36096 14.9423H6.00096C5.62096 14.9423 5.27096 14.7223 5.10096 14.3823C4.93096 14.0423 4.98096 13.6323 5.21096 13.3323L15.311 0.38233C15.611 0.00232983 16.131 -0.10767 16.561 0.11233C16.991 0.33233 17.201 0.83233 17.061 1.29233L14.721 9.06233H18.081C18.461 9.06233 18.811 9.28233 18.981 9.62233C19.151 9.96233 19.101 10.3723 18.871 10.6723L8.77096 23.6223C8.58096 23.8723 8.28096 24.0023 7.98096 24.0023ZM8.01096 12.7623L10.671 12.8823C10.991 12.8923 11.281 13.0623 11.451 13.3223C11.631 13.5823 11.671 13.9123 11.571 14.2123L10.211 18.1023L16.071 11.2423L13.371 11.0723C13.051 11.0723 12.761 10.9223 12.571 10.6723C12.381 10.4223 12.321 10.0923 12.421 9.78233L13.881 5.91233L8.01096 12.7723V12.7623Z',
    },
  ],
};
